import React, { useState, useEffect, useCallback } from "react";
import Navbar from "../../components/Navbar/Navbar";
import { AutoComplete, Breadcrumb, Button } from "antd";
import { DoubleRightOutlined, DownOutlined, DownloadOutlined } from "@ant-design/icons";
import ShimmerLoader from "../../loading";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../../Routes";
import LoadingSpinner from "../../components/Loading";
import {
  getAllStoreProductInformation,
  getInventoryallproducts,
  getInventoryEditResttriction,
  getProductHistory,
  getProductInfo,
  getProductPurchaseInfo,
  getProductSaleInfo,
  getProductSalePurchaseInfo,
  InventorySearchonboard,
  verifyInventoryPassword,
} from "../../API  Functions/InventoryFunctions";
import dummy_image from "../../assets/Images/gallery.svg";
import ProductPurchaseDetails from "./Tables/ProductPurchaseDetailsTable";
import ProductSaleDetailsTable from "./Tables/ProductSaleDetailsTable";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import SearchBox from "../CustomWidgets/SearchBox";
import AddPackageModal from "../../app/purchase/AddPackageModal";
import { URLS } from "../../API/API endpoints";
import axiosInstance from "../../AxiosInstance";
import { toast } from "react-toastify";
import ProductPackages from "./ProductPackages";
import AllStoreProductInfo from "./Tables/AllStoreProductInfoTable";
import { MultiSelectBox } from "../CustomWidgets/SelectBox";
import { getProductGroups } from "../../API  Functions/productGroupFunctions";
import Edit from "../../assets/Edit.svg";
import PasswordModal from "../../modals/PasswordModal";
import ProductHistoryTable from "./Tables/ProductHistoryTable";
import { GetRetailerDetails } from "../../API  Functions/ProfileFunctions";
import ExportCasInOutReportModal from "../../app/SessionHistory/ExportCasInOutReportModal";
import moment from "moment";
import ProductInfoExpire from "./Tables/ProductInfoExpire";

const { RangePicker } = DatePicker;

const debounce = (func, delay) => {
  let timer;
  return function (...args) {
    const context = this;
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(context, args), delay);
  };
};

const ReadOnly = ({ label, value }) => {
  const { t, i18n } = useTranslation();

  return (
    <div>
      <p className="text-xs text-gray-500 mb-1">{t(label)}</p>
      <p className=" border-gray-300 pb-1">{value || "-"}</p>
    </div>
  );
};

const Editable = ({ addCurrency, label, value, isEdit, onChange, readOnly, onKeyDown, ...props }) => {
  const { t, i18n } = useTranslation();

  return (
    <div>
      <p className="text-xs text-gray-500 mb-1">{t(label)}</p>

      {isEdit && !readOnly ? (
        <input
         {...props}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full border-b border-gray-400 outline-none py-1"
          onKeyDown={onKeyDown}
        />
      ) : (
        <p className="border-b border-gray-300 pb-1">{addCurrency ? 'EGP ' : ''}{value || "-"}</p>
      )}
    </div>
  );
};

const GroupField = ({
  label,
  value,
  allGroups,
  isEdit,
  onChange,
  toggleDeliveryFrom,
  readOnly,
}) => {
  const { t, i18n } = useTranslation();
  const displayValue = Array.isArray(value)
    ? value.map((item) => item.name).join(", ")
    : value;

  return (
    <div>
      <p className="text-xs text-gray-500 mb-1">{t(label)}</p>

      {isEdit && !readOnly ? (
        <MultiSelectBox
          //   label={t("S")}
          name="groups"
          onChange={(event) => {
            console.log("categories==>", event.target.value);
            toggleDeliveryFrom(event.target.value);
          }}
          placeholder={t("Select Groups")}
          defaultValue={[
            ...value?.map((item) => ({
              value: item?.id,
              label: i18n.language == "ar" ? item?.name_ar : item?.name,
            })),
          ]}
          options={[
            ...allGroups?.map((item) => ({
              value: item?.id,
              label: i18n.language == "ar" ? item?.name_ar : item?.name,
            })),
          ]}
        />
      ) : (
        // <input
        //   value={displayValue}
        //   onChange={e => onChange(e.target.value)}
        //   className="w-full border-b border-gray-400 outline-none py-1"
        // />
        <p className="border-b border-gray-300 pb-1">{displayValue || "-"}</p>
      )}
    </div>
  );
};

const ProductInfo = () => {
  const { t, i18n } = useTranslation();
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);

  const [loading, setloading] = useState(false);
  const [searchloading, setSearchloading] = useState(false);
  const [showPurchase, setShowPurchase] = useState(false);
  const [showSale, setShowSale] = useState(false);
  const [isPackageOpen, setIsPackageOpen] = useState(false);
  const [productHistoryOpen, setProductHistoryOpen] = useState(false);
  const [searchid, setsearchid] = useState(localStorage.getItem("searchid"));
  const [prodDetail, setProdDetail] = useState({});
  const [allStoreProdDetail, setAllStoreProdDetail] = useState([]);
  const [purchaseData, setPurchasedata] = useState([]);
  const [productHistory, setProductHistory] = useState([]);
  const [saleData, setSaleData] = useState({});
  const [currentLimit, setCurrentLimit] = useState(10); // Default limit
  const [currentOffset, setCurrentOffset] = useState(0); // Default offset
  const [dateRange, setDateRange] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [secondBarcode, setSecondaryBarcode] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [value, setValue] = useState("");
  const [Productoptions, setProductoptions] = useState([]);
  const [allGroups, setAllGroups] = useState([]);
  const [searchByShortCode, setSearchByShortCode] = useState(false);
  const [openInventoryPasswordModal, setOpenInventoryPasswordModal] = useState(false);
  const [inventoryEditResriction, setInventoryEditResriction] = useState(false);
    const [isEtaEnable, setIsEtaEnable] = useState(null);
  const [vatTypes, setVatTypes] = useState([]);
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [existingExpiryData, setExistingExpiryData] = useState(null);

  const userData = useSelector((state) => state?.login?.user?.result);
  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store,
  );
    const [taxId, setTaxId] = useState("");
  
  const EGS_PREFIX = `EG-${taxId}-`;


  const [formData, setFormData] = useState({
    sale_price: prodDetail?.sale_price || "",
    cost_price: prodDetail?.cost_price || "",
    group: prodDetail?.group_list || "",
    groupId: prodDetail?.group_list
      ? prodDetail.group_list.map((item) => item.id)
      : [],
    custom_name: prodDetail?.product_name2 || "",
    quantity: prodDetail?.available_qty || "",
    short_code: prodDetail?.product_shortcut || "",
    weighing_code: prodDetail?.machine_barcode || "",
    egs_code:prodDetail?.egs_code || "",
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("Id");

    if (id) {
      localStorage?.setItem("prodId", id);
    }

    const searchparam = id || localStorage.getItem("prodId");
    setsearchid(searchparam);

    if (searchparam) {
      setloading(true);
      GetProductSecondaryCode(searchparam);
      getProdInfo(searchparam);
      // GetProductHistory(searchparam, 0, 20);
      // getPurchaseInfo(searchparam);
      getAllStoreProductInfo(searchparam);
    }
    fetchdetails();
     GetVatTypes();
    CheckUserAcessForInventory();
  }, []);

   const GetProductExpiryData = async (id, limit, offset) => {
    const payload = {
      "company_id":company_id,
    "product_id": Number(id),
    "start_date":"",
    "end_date":"",
    "limit":limit,
    "offset":offset
    };
    try {
      const res = await axiosInstance.post(URLS.PRODUCT_EXPIRY_DETAILS, payload);
      const res1 = res?.data;

      // console.log("res1---->", res1);

      if (res1?.result?.status_code === 200) {
        setExistingExpiryData(res1?.result?.data);
      } else {
        setExistingExpiryData([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      // setloading(false);
    } finally {
      // setloading(false);
    }
  };

    const fetchdetails = () => {
      GetRetailerDetails(user_id).then((result) => {
        if (result) {
          setTaxId(
            result?.retailer_details?.tax_card_number
              ? result?.retailer_details?.tax_card_number
              : null,
          );
        }
      });
    };

      const GetVatTypes = async () => {
        const payload = {
          retailer_id: company_id,
          offset: 0,
          limit: 1000,
        };
        try {
          const res = await axiosInstance.post(URLS.GET_VAT_TYPES, payload);
          const res1 = res?.data;
    
          // console.log("res1---->", res1);
    
          if (res1?.result?.status_code === 200) {
              setVatTypes(res1?.result?.data?.filter(item => item.is_active));
          } else {
            setVatTypes([]);
          }
        } catch (error) {
          console.error("Error fetching KPI data:", error);
          // setloading(false);
        } finally {
          // setloading(false);
        }
      };
  

  // useEffect(()=>{
  // },[])

    const GetProductHistory = (searchid, offset, limit) => {
      if(searchid){
  getProductHistory(company_id, searchid, offset, limit).then((res) => {
      setloading(false);
      if(res?.status_code == 200){
     setProductHistory(res?.response)
      }else{
     setProductHistory([])
      }
      
    });
      }
  
  };

  const CheckUserAcessForInventory = async () => {
    try {
      const res = await getInventoryEditResttriction(user_id);
      if (res?.result?.status_code == 200) {
        setInventoryEditResriction(res?.result?.is_restrict_invetory_update);
         setIsEtaEnable(res?.result?.is_eta_enabled);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const getProdInfo = (searchid) => {
    getProductInfo(company_id, searchid).then((datagot) => {
      setloading(false);
      setProdDetail(datagot?.response);
      setFormData({
        sale_price: datagot?.response?.sale_price || "",
        cost_price: datagot?.response?.cost_price || "",
        group: datagot?.response?.group_list || "",
        groupId: datagot?.response?.group_list
          ? datagot?.response?.group_list.map((item) => item.id)
          : [],
        custom_name: datagot?.response?.product_name2 || "",
        quantity: datagot?.response?.available_qty || "",
        short_code: datagot?.response?.product_shortcut || "",
        weighing_code: datagot?.response?.machine_barcode || "",
        egs_code: datagot?.response?.egs_code || "",
      });
    });
  };

  const GetGroups = async () => {
    const payload = {
      lang: i18n.language === "ar" ? "ar_001" : "en_US",
      company_id: company_id,
      user_id: user_id,
      offset: 0,
      limit: 5000,
    };
    try {
      const res1 = await getProductGroups(payload);

      // console.log("res1---->", res1);

      if (res1?.result[0]?.status_code === 200) {
        setAllGroups(res1?.result[0]?.product_groups);
      } else {
        setAllGroups([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      // setloading(false);
    } finally {
      // setloading(false);
    }
  };

  const getAllStoreProductInfo = (searchid) => {
    getAllStoreProductInformation(company_id, searchid).then((datagot) => {
      setloading(false);
      console.log("ALL STOREEEE", datagot);

      setAllStoreProdDetail(datagot?.response || []);
    });
  };

  const getPurchaseInfo = (searchid,limit,offset
  ) => {
    getProductSalePurchaseInfo(
      company_id,
      searchid,
      limit,
      offset,
    ).then((datagot) => {
      setloading(false);
      setPurchasedata(datagot?.data || []);
    });
  };

  // const handleRangePickerChange = (dates) => {
  //   if (dates && dates.length === 2) {
  //     const [start, end] = dates;
  //     const formattedStart = dayjs(start).format("YYYY-MM-DD");
  //     const formattedEnd = dayjs(end).format("YYYY-MM-DD");
  //     setDateRange([formattedStart, formattedEnd]);

  //     getPurchaseInfo(searchid, formattedStart, formattedEnd);
  //   } else {
  //     setDateRange([]);
  //     getPurchaseInfo(searchid, "", "");
  //   }
  // };

  // const handleVendorSearchChange = (value) => {
  //   setSearchText(value);
  //   getPurchaseInfo(searchid, dateRange[0], dateRange[1], value);
  // };

  const handleCustomerSearchChange = (value) => {
    setSearchText(value);
  };

  const GetProductSecondaryCode = async (id) => {
    const payload = {
      company_id: company_id,
      product_id: Number(id),
      user_id: user_id,
    };
    try {
      const response = await axiosInstance.post(
        URLS.GET_SECONDARY_BARCODE,
        payload,
      );

      if (response?.data?.result[0]?.status_code === 200) {
        setSecondaryBarcode(response?.data?.result[0]?.response[0]?.barcode);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };
  //   console.log("purchaseData", purchaseData);

  const UpdatePackages = async (prodId, packs) => {
    setloading(true);
    try {
      let payload = {
        product_id: Number(prodId),
        company_id: company_id,
        packages: packs,
      };
      const response = await axiosInstance.post(
        URLS.UPDATE_PRODUCT_PACKAGE,
        payload,
      );
      // console.log("GetAllPackages===>", response?.data);
      if (response?.data?.result?.status_code == 200) {
        setloading(false);
        //  setIsPackageModalOpen(false);
        toast.success(t("Packs updated successfully"));
      } else {
        toast.error(t(response?.data?.result?.status));
        // setPackagesArray([])
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    } finally {
      setloading(false);
    }
  };

  const handlePrintLabel = (item) => {
    if (!item) return;

    // === SIZE SETTINGS ===
    const labelWidth = 5; // cm
    const labelHeight = 2; // cm

    const labelHTML = `
    <div style="
      width: 10cm;
      height: 10cm;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 0;
      margin: 0;
      font-family: Arial;
    ">

      <!-- LEFT LABEL -->
      <div style="
        width: ${labelWidth}cm;
        height: ${labelHeight}cm;
        border: 1px dashed #000;
        text-align: center;
        padding: 2px;
        box-sizing: border-box;
      ">
        <img 
          src="https://barcode.tec-it.com/barcode.ashx?data=${item.barcode}&code=Code128"
          style="width: 90%; height: 50%; object-fit: contain;"
        />
        <div style="font-size: 10px; font-weight: bold; line-height: 1;">
          ${item.name}
        </div>
        <div style="font-size: 10px;">EGP ${item.sale_price}</div>
        <div style="font-size: 9px; margin-top: 2px;">${item.barcode}</div>
      </div>

      <!-- RIGHT LABEL (same item or blank) -->
      <div style="
        width: ${labelWidth}cm;
        height: ${labelHeight}cm;
        border: 1px dashed #000;
        text-align: center;
        padding: 2px;
        box-sizing: border-box;
      ">
        <img 
          src="https://barcode.tec-it.com/barcode.ashx?data=${item.barcode}&code=Code128"
          style="width: 90%; height: 50%; object-fit: contain;"
        />
        <div style="font-size: 10px; font-weight: bold; line-height: 1;">
          ${item.name}
        </div>
        <div style="font-size: 10px;">EGP ${item.sale_price}</div>
        <div style="font-size: 9px; margin-top: 2px;">${item.barcode}</div>
      </div>

    </div>
  `;

    // === CREATE HIDDEN IFRAME ===
    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(`
    <html>
      <head>
        <style>
          @page {
            size: 10cm 2cm;   /* Full sheet size */
            margin: 0;
          }
          body {
            margin: 0;
            padding: 0;
          }
        </style>
      </head>
      <body>${labelHTML}</body>
    </html>
  `);
    doc.close();

    // === PRINT AUTOMATICALLY ===
    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    // Clean up
    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 1000);
  };

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  console.log("formData==>", formData);

   const verifyEgsCodeAPI = async (egsCode, prod_id) => {
      try {
        const body = {
          product_id: prod_id || 0, // if new product, send 0
          egs_code: egsCode,
          company_id,
        };
  
        const res = await axiosInstance.post(URLS.VERIFY_EGS_CODE, body);
  
        return res?.data;
        // Example expected: "Barcode already exists" or "Barcode available"
      } catch (error) {
        console.error("Error checking barcode:", error);
        return "error";
      }
    };

     const isValidEgsFilled = (egs) => {
    if (!egs) return false;
    if (egs === EGS_PREFIX) return false;
    return egs.length > EGS_PREFIX.length;
  };


  const handleSave = async () => {
    // API call here
    try {


          //   const oldEgs = prodDetail?.egs_code;
          // const newEgs = formData.egs_code;
      
          // const hadEgsBefore = isValidEgsFilled(oldEgs);
          // const hasEgsNow = isValidEgsFilled(newEgs);
      
          // // 👉 EGS entered now but wasn't there before
          // if (!hadEgsBefore && hasEgsNow) {
          //   try {
          //     const verifyRes = await verifyEgsCodeAPI(newEgs, Number(searchid));
      
          //     if (verifyRes?.result?.status_code !== 200) {
          //       toast.error(t("EGS code not verified"));
          //       setloading(false);
          //       return;
          //     }
          //   } catch (err) {
          //     toast.error(t("EGS code verification failed"));
          //     setloading(false);
          //     return;
          //   }
          // }
      // Sale price cannot be less than cost price
      if (
        formData?.sale_price !== "" &&
        formData?.cost_price !== "" &&
        Number(formData.sale_price) < Number(formData.cost_price)
      ) {
        toast.error(t("Sale price cannot be less than cost price"));
        return;
      }
      // Machine barcode must be exactly 7 digits OR empty
      if (formData?.weighing_code && !/^\d{7}$/.test(formData.weighing_code)) {
        toast.error(t("Weighing scale product code must be exactly 7 digits"));
        return;
      }
      setloading(true);
      const existingGroupIds = Array.isArray(formData?.group)
        ? formData.group.map((g) => g.id)
        : [];

      const removeGroupIds = existingGroupIds.filter(
        (id) => !formData.groupId.includes(id),
      );

      let payload = {
        product_id: Number(searchid),
        company_id: company_id,
        new_price: Number(formData?.sale_price),
        new_cost_price: Number(formData?.cost_price),
        machine_barcode: formData?.weighing_code,
        product_name2: formData?.custom_name,
        product_shortcut: formData?.short_code,
        new_quantity: Number(formData?.quantity),
        add_group_ids: formData?.groupId || [],
        remove_group_ids: removeGroupIds,
        // egs_code: formData?.egs_code,
      };
      const response = await axiosInstance.post(
        URLS.UPDATE_PRODUCT_INFO,
        payload,
      );
      // console.log("GetAllPackages===>", response?.data);
      if (response?.data?.result?.status_code == 200) {
        setIsEdit(false);
        getProdInfo(Number(searchid));
        // setloading(false);
        //  setIsPackageModalOpen(false);
        toast.success(t("Product updated successfully"));
      } else {
        toast.error(t(response?.data?.result?.status));
        // setPackagesArray([])
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    } finally {
      setloading(false);
    }
  };

  const searchResult = useCallback(
    debounce(async (value) => {
      const res = await getInventoryallproducts(
        user_id,
        company_id,
        false,
        false,
        value,
        10,
        0,
      );
      // console.log("API Response:", res);

      if (res?.result[0]?.response) {
        setSearchloading(false);
        setProductoptions(res.result[0].response);
      } else {
        setSearchloading(false);
        setProductoptions([]);
      }
    }, 500),
    [], // make sure this is not recreated on every render
  );

  const debouncedSearchbyCode = debounce(async (value) => {
    const productName = value === "" ? "" : value; // Set product_name as empty string if no value
    const limit = 10; // Set limit
    const offset = 0; // Set offset

    if (value === "") {
      // searchResult('');
    } else {
      let payload = {
        lang: i18n.language == "ar" ? "ar_001" : "en_US",
        short_code: productName,
        type: "all", //required // all or low or high or out
        company_id: company_id,
      };
      const response = await axiosInstance.post(
        URLS.GET_STOCK_BY_CODE,
        payload,
      );
      if (response?.data?.result[0]?.response) {
        setSearchloading(false);
        setProductoptions(response?.data?.result[0].response);
      } else {
        setSearchloading(false);
        setProductoptions([]);
      }
    }
  }, 1000);

  const resetProductEdit = () => {
    setIsEdit(false);
    setFormData({
      sale_price: prodDetail?.sale_price || "",
      cost_price: prodDetail?.cost_price || "",
      group: prodDetail?.group_list || "",
      groupId: prodDetail?.group_list
        ? prodDetail?.group_list.map((item) => item.id)
        : [],
      custom_name: prodDetail?.product_name2 || "",
      quantity: prodDetail?.available_qty || "",
      short_code: prodDetail?.product_shortcut || "",
      weighing_code: prodDetail?.machine_barcode || "",
         egs_code: prodDetail?.egs_code || "",
    });
  };

    const closePasswordModal = () => {
    setFormData({
      sale_price: prodDetail?.sale_price || "",
      cost_price: prodDetail?.cost_price || "",
      group: prodDetail?.group_list || "",
      groupId: prodDetail?.group_list
        ? prodDetail?.group_list.map((item) => item.id)
        : [],
      custom_name: prodDetail?.product_name2 || "",
      quantity: prodDetail?.available_qty || "",
      short_code: prodDetail?.product_shortcut || "",
      weighing_code: prodDetail?.machine_barcode || "",
         egs_code: prodDetail?.egs_code || "",
    });
    setIsEdit(false);
    setOpenInventoryPasswordModal(false);
  };

   const handlePasswordConfirm = async (password) => {
      try {
        const res = await verifyInventoryPassword(user_id, password);
        if (res?.result?.status_code == 200) {
          setOpenInventoryPasswordModal(false);
          handleSave();
        } else {
          toast.error(t(res?.result?.status));
        }
      } catch (error) {
        console.log(error);
      } finally {
      }
    };


      const handleExport = async (dates) => {
    let payload = {
      lang: i18n.language === "ar" ? "ar_001" : "en_US",
      // start_date: dates?.startDate,
      // end_date: dates?.endDate,
      product_id:searchid,
      company_id: company_id,
    };
    const response = await axiosInstance.post(
      URLS.GET_PRODUCT_HISTORY_EXCEL,
      payload
    );
    console.log("handleExport", response);
    if (response?.data?.result?.status_code == 200) {
      setExportModalOpen(false);
      downloadFile(response?.data?.result?.file_base64);
    } else {
      toast.error(response?.data?.result.status);
    }
  };

  const downloadFile = (base64Data) => {
    try {
      if (
        !base64Data ||
        typeof base64Data !== "string" ||
        base64Data.trim() === ""
      ) {
        alert("No valid file data available for download");
        return;
      }

      let cleanBase64 = base64Data
        .trim()
        .replace(/^data:[\w/+-]+;base64,/, "")
        .replace(/^["']|["']$/g, "")
        .replace(/\s/g, "");

      const padLength = 4 - (cleanBase64.length % 4);
      if (padLength < 4) cleanBase64 += "=".repeat(padLength);

      let binaryString = atob(cleanBase64);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const header = new Uint8Array(bytes.buffer, 0, 8);
      let mimeType = "application/octet-stream";
      let fileExtension = "bin";

      if (header[0] === 0x50 && header[1] === 0x4b) {
        mimeType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        fileExtension = "xlsx";
      } else if (
        header[0] === 0xd0 &&
        header[1] === 0xcf &&
        header[2] === 0x11 &&
        header[3] === 0xe0
      ) {
        mimeType = "application/vnd.ms-excel";
        fileExtension = "xls";
      } else if (new TextDecoder().decode(header).includes(",")) {
        mimeType = "text/csv";
        fileExtension = "csv";
      }

      const blob = new Blob([bytes], { type: mimeType });
      // const timestamp = new Date()
      //   .toISOString()
      //   .replace(/[:.]/g, "-")
      //   .replace("T", "_")
      //   .slice(0, 19);
      // const filename = `inventory_sale_summary_${timestamp}.${fileExtension}`;
      const timestamp = moment().format("YYYY-MM-DD_HH.mm.ss"); // Using period for time
      const filename = `${t(
        "sale_purchase_summary"
      )}_${timestamp}.${fileExtension}`;

      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("File download failed:", error);
      alert(`Download failed: ${error.message || "Unknown error"}`);
    }
  };

  return (
    <>
     {openInventoryPasswordModal === true && (
        <PasswordModal
          onCancel={closePasswordModal}
          onConfirm={handlePasswordConfirm}
        />
      )}
      {loading && <LoadingSpinner />}
      <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto  bg-[#F6F7F9]">
        <Navbar heading="inventory" />
        <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden ms-3">
          {loading ? (
            <ShimmerLoader />
          ) : (
            <>
              <div className="font-extrabold">
                <Breadcrumb
                  separator={<DoubleRightOutlined />}
                  items={[
                    {
                      title: (
                        <Link to={routes.inventory.root}>{t("inventory")}</Link>
                      ),
                      key: "inventory",
                    },
                    { title: t("Product Details") },
                  ]}
                  className="relative mt-3 font-semibold"
                />
              </div>

              <div className="flex justify-between items-center mb-4 mt-4 me-5">
                <div className="flex items-center mt-2 w-6/12 pe-5">
                  {/* <h2 className="text-xs font-medium">{"Search Products"}</h2> */}
                  <div className="relative me-2 w-9/12">
                    <AutoComplete
                      value={value}
                      options={Productoptions.map((option) => ({
                        value: option.quant_id,
                        label:
                          option.product_name2 && option.product_name2 != ""
                            ? option.product_name2
                            : option.product_name,
                      }))}
                      onSearch={(value) => {
                        // if (!isProductSelected) {
                        setValue(value);
                        if (searchByShortCode) {
                          debouncedSearchbyCode(value);
                          setSearchloading(true);
                        } else {
                          if (value.length >= 3) {
                            setSearchloading(true);
                            searchResult(value);
                          } else {
                            setProductoptions([]);
                            setSearchloading(true);
                          }
                        }

                        // }
                      }}
                      onSelect={(value) => {
                        console.log("valllll=>", value);

                        setloading(true);
                        setsearchid(value);
                        GetProductSecondaryCode(value);
                        getProdInfo(value);
                        getPurchaseInfo(value, 10, 0)
                        GetProductExpiryData(value, 10, 0);
                        getAllStoreProductInfo(value);
                        setProductoptions([]);
                        setValue("");
                        setIsEdit(false);
                        // setProductoptions([]);
                      }}
                      style={{ width: "100%", height: "38px" }}
                      className=""
                      placeholder={t("search_product")}
                      // readOnly={isProductSelected}
                      // disabled={isAddBarcodeModalOpen}
                    />
                    {searchloading && (
                      <div
                        className={`absolute ${
                          i18n.language === "ar" ? "left-8" : "right-8"
                        } top-3 flex items-center`}
                      >
                        <svg
                          className="animate-spin h-4 w-4 text-gray-500"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                          />
                        </svg>
                      </div>
                    )}
                    {value && (
                      <button
                        type="button"
                        onClick={() => {
                          setValue(""); // Clear the input value
                          setProductoptions([]);
                        }}
                        className={`absolute ${
                          i18n.language === "ar" ? "left-2" : "right-2"
                        } top-2 text-gray-500 hover:text-gray-700`}
                        // className="absolute right-2 top-2 text-gray-500 hover:text-gray-700"
                      >
                        &times;
                      </button>
                    )}
                  </div>
                  <button
                    type="button"
                    onClick={() => {
                      setValue("");
                      setProductoptions([]);
                      setSearchByShortCode(!searchByShortCode);
                    }}
                    className={`h-[40px] px-2 rounded-md border text-sm whitespace-nowrap
    ${
      searchByShortCode
        ? "bg-blue-100 border-primaryBlue text-primaryBlue"
        : "bg-white border-gray-300 text-gray-700"
    }`}
                  >
                    {t("Search Code")}
                  </button>
                </div>
                {!allStores && (
                  <>
                    {!isEdit ? (
                      // <button
                      //   onClick={() => {
                      //     setIsEdit(true);
                      //     GetGroups();
                      //   }}
                      //   className="w-9 h-9 border rounded-lg flex items-center justify-center hover:bg-gray-100"
                      // >
                      //   ✏️
                      // </button>
                      <div
                        onClick={() => {
                          setIsEdit(true);
                          GetGroups();
                        }}
                        className="w-9 h-9 border rounded-lg flex items-center justify-center hover:bg-gray-100"
                      >
                        <img
                          src={Edit}
                          style={{
                            cursor: "pointer",
                            height: "1rem",
                            width: "1rem",
                          }}
                          alt="Edit"
                        />
                      </div>
                    ) : (
                      <div className="flex">
                        <button
                          onClick={resetProductEdit}
                          className="px-6 py-2 me-2 border border-primaryBlue bg-white text-primaryBlue rounded-lg text-sm font-semibold"
                        >
                          {t("Cancel")}
                        </button>
                        <button
                          onClick={() => {
                            const isPriceChanged =
  Number(formData?.quantity) !== Number(prodDetail?.available_qty) ||
  Number(formData?.sale_price) !== Number(prodDetail?.sale_price) ||
  Number(formData?.cost_price) !== Number(prodDetail?.cost_price);

if (inventoryEditResriction && isPriceChanged) {
          setOpenInventoryPasswordModal(true);

  // block save (show error / modal / toast)
  // example:
  // toast.error("You are not allowed to change price or quantity");
} else {
  handleSave();
}
                          }}
                          className="px-6 py-2 bg-primaryBlue text-white rounded-lg text-sm font-semibold"
                        >
                          {t("Save")}
                        </button>
                      </div>
                    )}
                  </>
                )}
              </div>
              <div className="bg-white rounded-lg shadow-md p-6">
                {/* Top section (READ ONLY) */}

                <div className="flex gap-8 mb-8 items-center">
                  <div className="w-56 h-56 border rounded-lg flex items-center justify-center overflow-hidden px-2 py-4">
                    <img
                      src={prodDetail?.image || dummy_image}
                      alt=""
                      className="object-contain w-full h-full"
                    />
                  </div>
                  <div className="flex-1">
                    <h2 className="text-xl font-semibold mb-3">
                      {prodDetail?.name}
                    </h2>

                    <div className="grid grid-cols-3 gap-x-12 gap-y-6 ">
                      <ReadOnly label="Barcode" value={prodDetail?.barcode} />
                      {/* <ReadOnly label="EGS Code" value={prodDetail?.egs_code} /> */}
                      <ReadOnly
                        label="Category"
                        value={prodDetail?.categ_name}
                      />
                      <ReadOnly
                        label="Sub Category"
                        value={prodDetail?.sub_categ_name}
                      />
                      <ReadOnly
                        label="Current Stock Value"
                        value={`EGP ${(prodDetail?.cost_price * prodDetail?.available_qty)?.toFixed(2)}`}
                      />
                      <ReadOnly
                        label="Product Uom"
                        value={prodDetail?.uom}
                      />
                       <ReadOnly
                        label="First added on"
                        value={prodDetail?.addon_date}
                      />
                       <ReadOnly
                        label="Last updated on"
                        value={prodDetail?.last_update_date}
                      />
                    </div>
                    <div className="grid grid-cols-3 gap-x-12 gap-y-6 mt-5">
                      <Editable
                        addCurrency={true}
                        label="Cost Price"
                        value={formData.cost_price}
                        isEdit={isEdit}
                        onChange={(v) => {
                          if (
                            /^\d*(\.\d{0,2})?$/.test(v) &&
                            (v === "" || Number(v) <= 100000)
                          ) {
                            handleChange("cost_price", v);
                          }
                        }}
                      />

                      <Editable
                        addCurrency={true}
                        label="Sale Price"
                        value={formData.sale_price}
                        isEdit={isEdit}
                        onChange={(v) => {
                          if (
                            /^\d*(\.\d{0,2})?$/.test(v) &&
                            (v === "" || Number(v) <= 100000)
                          ) {
                            handleChange("sale_price", v);
                          }
                        }}
                      />

                      <Editable
                        label="Quantity"
                        value={formData.quantity}
                        isEdit={isEdit}
                        onChange={(v) => {
                          if (
                            /^\d*(\.\d{0,2})?$/.test(v) &&
                            (v === "" || Number(v) <= 100000)
                          ) {
                            handleChange("quantity", v);
                          }
                        }}
                      />
                      <Editable
                        label="Custom Product Name"
                        readOnly={
                          userData?.is_sub_store || userData?.is_warehouse
                        }
                        value={formData.custom_name}
                        isEdit={isEdit}
                        onChange={(v) => {
                          handleChange("custom_name", v);
                          // if (v.length <= 50) {
                          //   handleChange("custom_name", v);
                          // }
                        }}
                      />
<Editable
                        label="EGS Code"
                        readOnly={
                          userData?.is_sub_store || userData?.is_warehouse
                        }
                        value={
                            formData.egs_code?.startsWith(EGS_PREFIX)
                              ? formData.egs_code
                              : EGS_PREFIX
                          }
                        isEdit={isEdit}
                        maxLength={30}
                          onChange={(value) => {
                            // let value = event.target.value;

                            // If user tries to delete prefix, restore it
                            if (!value.startsWith(EGS_PREFIX)) {
                              value = EGS_PREFIX;
                            }

                            // Allow only digits after prefix
                            const suffix = value
                              .slice(EGS_PREFIX.length)
                              .replace(/[^0-9]/g, "");

                            handleChange(
                              "egs_code",
                              EGS_PREFIX + suffix,
                            );
                          }}
                          onKeyDown={(e) => {
                            const cursorPosition = e.target.selectionStart;

                            // Prevent backspace/delete inside prefix
                            if (
                              (e.key === "Backspace" || e.key === "Delete") &&
                              cursorPosition <= EGS_PREFIX.length
                            ) {
                              e.preventDefault();
                            }
                          }}
                      />
                      <Editable
                        label="Product Short Code"
                        readOnly={
                          userData?.is_sub_store || userData?.is_warehouse
                        }
                        value={formData.short_code}
                        isEdit={isEdit}
                        onChange={(v) => {
                          if (/^\d*$/.test(v) && v.length <= 10) {
                            handleChange("short_code", v);
                          }
                        }}
                      />

                      <Editable
                        label="Weighing Scale Product Code"
                        readOnly={
                          userData?.is_sub_store ||
                          userData?.is_warehouse ||
                          prodDetail?.uom == "Units" || prodDetail?.uom == "Bundle" || prodDetail?.uom == 'الوحدات'
                        }
                        value={formData.weighing_code}
                        isEdit={isEdit}
                        onChange={(v) => {
                          if (/^\d*$/.test(v) && v.length <= 7) {
                            handleChange("weighing_code", v);
                          }
                        }}
                      />

                      <GroupField
                        label="Product Groups"
                        value={formData.group}
                        readOnly={
                          userData?.is_sub_store || userData?.is_warehouse
                        }
                        isEdit={isEdit}
                        allGroups={allGroups}
                        // onChange={v => handleChange("group", v)}
                        toggleDeliveryFrom={(v) => handleChange("groupId", v)}
                      />
                    </div>
                  </div>
                </div>

                {/* Divider */}
                {/* <div className="border-t my-6" /> */}

                {/* Editable section (BOTTOM ONLY) */}
              </div>

              {(prodDetail?.uom === "Units" ||
                prodDetail?.uom === "الوحدات") && (
                <div className="mt-6 bg-white rounded-lg flex flex-col items-start">
                  <div className="flex justify-between items-center px-4 ">
                    <button
                      onClick={() => setIsPackageOpen(!isPackageOpen)}
                      className="flex items-center gap-2 text-black px-4 py-4 text-lg font-semibold rounded  transition-all"
                    >
                      {t("Packages")}
                      <DownOutlined
                        className={`transition-transform duration-300 ${
                          isPackageOpen ? "rotate-180" : "rotate-0"
                        }`}
                      />
                    </button>
                  </div>

                  {isPackageOpen && (
                    <ProductPackages
                      onClose={() => {
                        setIsPackageOpen(false);
                      }}
                      productId={Number(searchid)}
                      savedPackages={null}
                      onSavePackages={UpdatePackages}
                      prodDetail={prodDetail}
                    />
                  )}
                </div>
              )}

              {allStores && (
                <div className="mt-6 bg-white rounded-lg">
                  <br></br>
                  <div className="font-semibold text-lg ms-5 ">
                    {t("Store-Wise Product Details")}
                  </div>
                  <AllStoreProductInfo
                    additionalData={allStoreProdDetail}
                    handleReferesh={() => getAllStoreProductInfo(searchid)}
                    // pagination={(values) => {
                    //   setCurrentLimit(values.limit);
                    //   setCurrentOffset(values.offset);
                    //   getAllStoreProductInfo(
                    //     company_id,
                    //     searchid
                    //     // values.limit,
                    //     // values.offset
                    //   );
                    // }}
                  />
                </div>
              )}

              <div className="mt-6 bg-white rounded-lg">
                <br></br>
                <div className="flex justify-between items-center">
                <div className="font-semibold text-lg ms-5 ">
                  {t("Sales & Purchases Summary")}
                </div>
                  <div className=" flex justify-end mx-8">
                                <button
                                  className="w-48 h-10 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center gap-2"
                                  // onClick={() => setExportModalOpen(true)}
                                  onClick={() => {
                                      handleExport();
                                  }}
                                >
                                  <DownloadOutlined
                                    style={{ fontSize: "1.5em", MozMarginStart: -10 }}
                                  />
                
                                  <span>{t("Download in Excel")}</span>
                                </button>
                              </div>
                              </div>
                <ProductPurchaseDetails
                  additionalData={purchaseData}
                  pagination={(values) => {
                    // setCurrentLimit(values.limit);
                    // setCurrentOffset(values.offset);
                    getPurchaseInfo(searchid,values.limit,values.offset);
                  }}
                />
              </div>

              <div className="mt-6 bg-white rounded-lg">
                <br></br>
                <div className="font-semibold text-lg ms-5 ">
                  {t("Product Expiry")}
                </div>
                <ProductInfoExpire
                  additionalData={existingExpiryData}
                  pagination={(values) => {
                    // setCurrentLimit(values.limit);
                    // setCurrentOffset(values.offset);
                    GetProductExpiryData(searchid,values.limit,values.offset);
                  }}
                />
              </div>

             <div className="mt-6 bg-white rounded-lg mb-5">

  <div
    onClick={() => setProductHistoryOpen(!productHistoryOpen)}
    className="flex items-center px-5 py-4 cursor-pointer "
  >
    <span className="font-semibold text-lg">
      {t("Product History")}
    </span>

    <DownOutlined
      className={`transition-transform duration-300 text-gray-600 ms-2 ${
        productHistoryOpen ? "rotate-180" : "rotate-0"
      }`}
    />
  </div>

  {productHistoryOpen && (
    <ProductHistoryTable
      additionalData={productHistory}
      pagination={(values) => {
        GetProductHistory(searchid, values.offset, values.limit);
      }}
    />
  )}

</div>

            </>
          )}
        </div>
          {/* {exportModalOpen && (
        <ExportCasInOutReportModal
          heading={t("Download Sales & Purchases Summary")}
          isOpen={exportModalOpen}
          onClose={() => setExportModalOpen(false)}
          onExport={(dates) => handleExport(dates)}
        />
      )} */}
      </div>
    </>
  );
};

export default ProductInfo;